import { render, staticRenderFns } from "./PaymentProviderInfo.vue?vue&type=template&id=09b0b7d7&scoped=true&"
var script = {}
import style0 from "./PaymentProviderInfo.vue?vue&type=style&index=0&id=09b0b7d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b0b7d7",
  null
  
)

export default component.exports